import {
  Loadable,
  Model,
  ModelAttributes,
  ModelDescription,
  model,
  modelConfig,
  reference,
} from "@mixitone/oom";
import TournamentCompetition from "./TournamentCompetition";
import { setAccountId } from "./concerns/SetAccountId";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    base_event_id: {
      type: "string",
    },
    client_id: {
      type: "string",
    },
    client_seq: {
      type: "number",
    },
    club_id: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    event_type: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    payload: {
      type: "json",
      jsonType: {} as Record<string, any>,
    },
    tournament_competition_id: {
      type: "string",
    },
    updated_at: {
      type: "datetime",
    },
  },
  {},
  {
    competition: reference(() => TournamentCompetition as any, "tournament_competition_id"),
  },
);

interface TournamentCompetitionEvent extends ModelAttributes<typeof config> {
  competition: Loadable<TournamentCompetition>;
}

@setAccountId
@model("tournament_competition_events", config)
class TournamentCompetitionEvent extends Model<typeof config> {
  static readonly modelDescription: ModelDescription = {
    description:
      "Immutable tournament domain event used to build deterministic tournament state. " +
      "Each event has a client sequence for idempotency and conflict handling.",
    availableFields: [...Object.keys(config.fields)],
    relationships: {
      competition: "tournament_competitions where id equals this tournament_competition_id",
    },
  };
}

export default TournamentCompetitionEvent;
